// src/pages/AuthContext.js
import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  console.log("🔵 AuthContext chargé");

  const [user, setUser] = useState(null);
  const [currentSite, setCurrentSite] = useState(
    localStorage.getItem("currentSite")
      ? JSON.parse(localStorage.getItem("currentSite"))
      : null
  );

  // ------------------------------------------------
  // 📌 Décodage automatique du token
  // ------------------------------------------------
  useEffect(() => {
    console.log("🟦 Vérification du token...");

    const token = localStorage.getItem("token");

    if (!token) {
      console.log("⚪ Aucun token trouvé.");
      return;
    }

    try {
      console.log("🔍 Token trouvé :", token);

      const decoded = jwtDecode(token);
      console.log("🟩 Token décodé :", decoded);

      const newUser = {
        token,
        id: decoded.id,
        nom: decoded.nom,
        prenom: decoded.prenom || null,
        type_user: decoded.type_user,
        entrepriseId: decoded.entrepriseId,
        entrepriseNom: decoded.entrepriseNom,
        siteId: decoded.siteId || null,
        siteNom: decoded.siteNom || null,
        date_creation:
          decoded.type_user === "gestionnaire"
            ? decoded.date_creation || null
            : null,
      };

      console.log("🟢 User reconstruit :", newUser);

      setUser(newUser);
      localStorage.setItem("user", JSON.stringify(newUser));

      // Gestionnaire → initialisation automatique du site
      if (
        newUser.type_user === "gestionnaire" &&
        newUser.siteId &&
        newUser.siteNom
      ) {
        const siteObj = { id: newUser.siteId, nom: newUser.siteNom };

        console.log("🏪 Site auto attribué :", siteObj);

        setCurrentSite(siteObj);
        localStorage.setItem("currentSite", JSON.stringify(siteObj));
      }
    } catch (err) {
      console.error("❌ Erreur lors du décodage :", err);

      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("currentSite");

      setUser(null);
      setCurrentSite(null);
    }
  }, []);

  // ------------------------------------------------
  // 📌 LOGIN
  // ------------------------------------------------
  const login = (token) => {
    console.log("🟦 LOGIN avec token :", token);

    const decoded = jwtDecode(token);
    console.log("🟩 Token décodé (login) :", decoded);

    const newUser = {
      token,
      id: decoded.id,
      nom: decoded.nom,
      prenom: decoded.prenom || null,
      type_user: decoded.type_user,
      entrepriseId: decoded.entrepriseId,
      entrepriseNom: decoded.entrepriseNom,
      siteId: decoded.siteId || null,
      siteNom: decoded.siteNom || null,
      date_creation:
        decoded.type_user === "gestionnaire"
          ? decoded.date_creation || null
          : null,
    };

    console.log("🟢 User créé (login) :", newUser);

    setUser(newUser);

    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(newUser));

    // Gestionnaire → site auto
    if (
      newUser.type_user === "gestionnaire" &&
      newUser.siteId &&
      newUser.siteNom
    ) {
      const siteObj = { id: newUser.siteId, nom: newUser.siteNom };

      console.log("🏪 Site auto (login) :", siteObj);

      setCurrentSite(siteObj);
      localStorage.setItem("currentSite", JSON.stringify(siteObj));
    }
  };

  // ------------------------------------------------
  // 📌 Sélection manuelle du site (entreprise)
  // ------------------------------------------------
  const selectSite = (site) => {
    console.log("🟦 selectSite →", site);

    setCurrentSite(site);
    localStorage.setItem("currentSite", JSON.stringify(site));

    console.log("💾 Site sélectionné sauvegardé :", site);
  };

  // ------------------------------------------------
  // 📌 LOGOUT
  // ------------------------------------------------
  const logout = () => {
    console.log("🔴 Déconnexion...");

    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("currentSite");

    setUser(null);
    setCurrentSite(null);

    console.log("🟣 Déconnexion terminée.");
  };

  return (
    <AuthContext.Provider
      value={{ user, login, logout, currentSite, selectSite }}
    >
      {children}
    </AuthContext.Provider>
  );
};
